import { environment } from '@env/environment';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Logger } from '../logger.service';

@Injectable()
export class CanActivateAdminModuleGuard {
  constructor(private router: Router) {}

  canActivate() {
    if (environment.Apps.ReflecxApp) {
      return true;
    }
    this.router.navigate(['']);
    return false;
  }

  canActivateChild() {
    if (environment.Apps.ReflecxApp) {
      return true;
    }
    this.router.navigate(['']);
    return false;
  }
}
